// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__28TIt","emails":"CreateEditClinics_emails__CR6gy","emailTagLabel":"CreateEditClinics_emailTagLabel__2XKOk"};